<template>
  <v-container fluid>
    <base-material-card
      icon="mdi-clipboard-text"
      :title="$t('tax.tax-primary-type')"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="footerProps"
        multi-sort
      >
        <template v-slot:top="{pagination, options, updateOptions}">
          <v-data-footer 
            :pagination="pagination" 
            :options="options"
            @update:options="updateOptions"
            :show-first-last-page="true"
            :show-current-page="true"
            first-icon="mdi-chevron-double-left"
            last-icon="mdi-chevron-double-right"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            :items-per-page-options="[20, 50, 100]"
          />
        </template>
        <template v-slot:item.name="{ item }">
          {{ get_type_name(item) }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import BaseTable from "./BaseTable.vue";
export default {
  data: (vm) => ({
    url: "/commodity/tax-primary-type/",
    headersMap: {
      id:{
        sortable: true,
        text: vm.$i18n.t("ID"),
        value: "id",
      },
      name_tc:{
        sortable: true,
        text: vm.$i18n.t("name"),
        value: "name_tc",
      },
      name_sc:{
        sortable: true,
        text: vm.$i18n.t("name"),
        value: "name_sc",
      },
    },
    tcHeaders: ['id', 'name_tc'],
    scHeaders: ['id', 'name_sc'],
  }),
  mixins: [BaseTable],
  methods: {
    get_type_name(item) {
      return this.getHanText(item, "name");
    },
  },
};
</script>